import { useState, useEffect } from 'react';

const useBrowserTabActive = () => {
  const [isBrowserTabActive, setIsBrowserTabActive] = useState(false);

  useEffect(() => {
    const handleDocumentVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        setIsBrowserTabActive(true);
      } else if (document.visibilityState === 'hidden') {
        setIsBrowserTabActive(false);
      }
    };

    document.addEventListener('visibilitychange', handleDocumentVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleDocumentVisibilityChange);
  }, []);

  return { isBrowserTabActive };
};

export default useBrowserTabActive;
